export default __webpack_public_path__ + "static/media/Logo_AgriboisValeur_transparent.661c96e6.png";